/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: grxNYctbMek6PL66cujx3u
// Component: 25u6_6Q-fQwp

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Portal } from "@/common/fragment/components/portal"; // plasmic-import: 8JnrBOuqUY30/codeComponent
import { Reveal } from "@plasmicpkgs/react-awesome-reveal";
import { AppFrame } from "@/modules/hamdast/appFrame"; // plasmic-import: m7qJ9qUrvaxd/codeComponent
import { ApiRequest } from "@/common/fragment/components/api-request"; // plasmic-import: IpxudV5ARc89/codeComponent
import Paziresh24Modal from "../../Paziresh24Modal"; // plasmic-import: ZGdhyEBPJSmH/component
import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import Paziresh24Button from "../../Paziresh24Button"; // plasmic-import: YOhw5fIQJQgB/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: grxNYctbMek6PL66cujx3u/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: grxNYctbMek6PL66cujx3u/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: grxNYctbMek6PL66cujx3u/projectcss
import sty from "./PlasmicLauncherComponentsApp.module.css"; // plasmic-import: 25u6_6Q-fQwp/css

import XIcon from "./icons/PlasmicIcon__X"; // plasmic-import: vvmOP9mnVRyD/icon
import ChevronRightIcon from "../paziresh_24_design_system/icons/PlasmicIcon__ChevronRight"; // plasmic-import: 0359howWu0cr/icon
import ChevronLeftIcon from "../paziresh_24_design_system/icons/PlasmicIcon__ChevronLeft"; // plasmic-import: jS0YlkKPLO7U/icon
import LauncherIconsLoaderIcon from "./icons/PlasmicIcon__LauncherIconsLoader"; // plasmic-import: 4lP5I8e4Rz71/icon
import Icon10Icon from "./icons/PlasmicIcon__Icon10"; // plasmic-import: 1jPTG-TWN6hw/icon

createPlasmicElementProxy;

export type PlasmicLauncherComponentsApp__VariantMembers = {
  soon: "soon";
  _new: "_new";
};
export type PlasmicLauncherComponentsApp__VariantsArgs = {
  soon?: SingleBooleanChoiceArg<"soon">;
  _new?: SingleBooleanChoiceArg<"_new">;
};
type VariantPropType = keyof PlasmicLauncherComponentsApp__VariantsArgs;
export const PlasmicLauncherComponentsApp__VariantProps =
  new Array<VariantPropType>("soon", "_new");

export type PlasmicLauncherComponentsApp__ArgsType = {
  name?: string;
  link?: string;
  avatar?: string;
  description?: string;
  widgetId?: string;
  widgetFrame?: boolean;
  onEvent?: () => void;
  appkey?: string;
  pagekey?: string;
  pageQuery?: any;
  showUsers?: boolean;
};
type ArgPropType = keyof PlasmicLauncherComponentsApp__ArgsType;
export const PlasmicLauncherComponentsApp__ArgProps = new Array<ArgPropType>(
  "name",
  "link",
  "avatar",
  "description",
  "widgetId",
  "widgetFrame",
  "onEvent",
  "appkey",
  "pagekey",
  "pageQuery",
  "showUsers"
);

export type PlasmicLauncherComponentsApp__OverridesType = {
  root?: Flex__<"div">;
  fragmentPortal?: Flex__<typeof Portal>;
  hamdastAppFrame?: Flex__<typeof AppFrame>;
  apiRequest?: Flex__<typeof ApiRequest>;
  modal?: Flex__<typeof Paziresh24Modal>;
  sideEffect?: Flex__<typeof SideEffect>;
  paziresh24Button?: Flex__<typeof Paziresh24Button>;
  apiRequest2?: Flex__<typeof ApiRequest>;
  modal2?: Flex__<typeof Paziresh24Modal>;
};

export interface DefaultLauncherComponentsAppProps {
  name?: string;
  link?: string;
  avatar?: string;
  description?: string;
  widgetId?: string;
  widgetFrame?: boolean;
  onEvent?: () => void;
  appkey?: string;
  pagekey?: string;
  pageQuery?: any;
  showUsers?: boolean;
  soon?: SingleBooleanChoiceArg<"soon">;
  _new?: SingleBooleanChoiceArg<"_new">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch { }
  return undefined;
}

function PlasmicLauncherComponentsApp__RenderFunc(props: {
  variants: PlasmicLauncherComponentsApp__VariantsArgs;
  args: PlasmicLauncherComponentsApp__ArgsType;
  overrides: PlasmicLauncherComponentsApp__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          widgetFrame: false,
          pageQuery: {},
          showUsers: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const $globalActions = useGlobalActions?.();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "soon",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.soon
      },
      {
        path: "apiRequest.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest"
      },
      {
        path: "apiRequest.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest"
      },
      {
        path: "apiRequest.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest"
      },
      {
        path: "isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "modal.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "_new",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props._new
      },
      {
        path: "page",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 1
      },
      {
        path: "showPaginationButton",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => true
      },
      {
        path: "userList",
        type: "private",
        variableType: "array",
        initFunc: ({ $props, $state, $queries, $ctx }) => []
      },
      {
        path: "isUsersLoading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => true
      },
      {
        path: "clickUserLoading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "apiRequest2.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "apiRequest2.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "apiRequest2.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,

        refName: "apiRequest2"
      },
      {
        path: "modal2.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootsoon]: hasVariant($state, "soon", "soon") }
      )}
    >
      {(() => {
        try {
          return true;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <Portal
          data-plasmic-name={"fragmentPortal"}
          data-plasmic-override={overrides.fragmentPortal}
          className={classNames("__wab_instance", sty.fragmentPortal)}
          container={(() => {
            try {
              return globalThis.document.body;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          {(() => {
            try {
              return $state.isOpen;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <Reveal
              className={classNames("__wab_instance", sty.reveal__uJw7O)}
              duration={400}
              triggerOnce={true}
            >
              <Reveal
                className={classNames("__wab_instance", sty.reveal___56UiD)}
                direction={"up"}
                duration={500}
                triggerOnce={true}
              >
                <div className={classNames(projectcss.all, sty.freeBox__h9WDu)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ojupf)}
                    onClick={async event => {
                      const $steps = {};

                      $steps["updateIsOpen"] = true
                        ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["isOpen"]
                            },
                            operation: 0,
                            value: false
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                        : undefined;
                      if (
                        $steps["updateIsOpen"] != null &&
                        typeof $steps["updateIsOpen"] === "object" &&
                        typeof $steps["updateIsOpen"].then === "function"
                      ) {
                        $steps["updateIsOpen"] = await $steps["updateIsOpen"];
                      }
                    }}
                  >
                    <XIcon
                      className={classNames(projectcss.all, sty.svg__crQ4N)}
                      role={"img"}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__vjSbm)}
                  >
                    <AppFrame
                      data-plasmic-name={"hamdastAppFrame"}
                      data-plasmic-override={overrides.hamdastAppFrame}
                      appKey={(() => {
                        try {
                          return $props.appkey;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      className={classNames(
                        "__wab_instance",
                        sty.hamdastAppFrame
                      )}
                      params={(() => {
                        try {
                          return [$props.pagekey];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      queries={(() => {
                        try {
                          return $props.pageQuery;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                    />
                  </div>
                </div>
              </Reveal>
            </Reveal>
          ) : null}
        </Portal>
      ) : null}
      <div
        className={classNames(projectcss.all, sty.freeBox__wxtDc, {
          [sty.freeBoxsoon__wxtDcwdK6]: hasVariant($state, "soon", "soon")
        })}
        onClick={async event => {
          const $steps = {};

          $steps["updateIsOpen"] =
            !!$props.link && !$state.soon && $props.widgetFrame
              ? (() => {
                const actionArgs = {
                  variable: {
                    objRoot: $state,
                    variablePath: ["isOpen"]
                  },
                  operation: 0,
                  value: true
                };
                return (({ variable, value, startIndex, deleteCount }) => {
                  if (!variable) {
                    return;
                  }
                  const { objRoot, variablePath } = variable;

                  $stateSet(objRoot, variablePath, value);
                  return value;
                })?.apply(null, [actionArgs]);
              })()
              : undefined;
          if (
            $steps["updateIsOpen"] != null &&
            typeof $steps["updateIsOpen"] === "object" &&
            typeof $steps["updateIsOpen"].then === "function"
          ) {
            $steps["updateIsOpen"] = await $steps["updateIsOpen"];
          }

          $steps["goToPage"] =
            !!$props.link && !$state.soon && !$props.widgetFrame
              ? (() => {
                const actionArgs = {
                  destination: (() => {
                    try {
                      return $props.link;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()
                };
                return (({ destination }) => {
                  if (
                    typeof destination === "string" &&
                    destination.startsWith("#")
                  ) {
                    document
                      .getElementById(destination.substr(1))
                      .scrollIntoView({ behavior: "smooth" });
                  } else {
                    __nextRouter?.push(destination);
                  }
                })?.apply(null, [actionArgs]);
              })()
              : undefined;
          if (
            $steps["goToPage"] != null &&
            typeof $steps["goToPage"] === "object" &&
            typeof $steps["goToPage"].then === "function"
          ) {
            $steps["goToPage"] = await $steps["goToPage"];
          }

          $steps["runOnEvent"] = true
            ? (() => {
              const actionArgs = { eventRef: $props["onEvent"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
            : undefined;
          if (
            $steps["runOnEvent"] != null &&
            typeof $steps["runOnEvent"] === "object" &&
            typeof $steps["runOnEvent"].then === "function"
          ) {
            $steps["runOnEvent"] = await $steps["runOnEvent"];
          }
        }}
      >
        <div className={classNames(projectcss.all, sty.freeBox___3Yal5)}>
          <PlasmicImg__
            alt={""}
            className={classNames(sty.img__vnPue, {
              [sty.imgsoon__vnPuewdK6]: hasVariant($state, "soon", "soon")
            })}
            displayHeight={"46px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"46px"}
            height={"46"}
            loading={"lazy"}
            src={(() => {
              try {
                return $props.avatar;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            width={"46"}
          />

          <div
            className={classNames(projectcss.all, sty.freeBox___94WL, {
              [sty.freeBoxsoon___94WLwdK6]: hasVariant($state, "soon", "soon")
            })}
          >
            <div
              className={classNames(projectcss.all, sty.freeBox___9RkNp, {
                [sty.freeBoxsoon___9RkNPwdK6]: hasVariant(
                  $state,
                  "soon",
                  "soon"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wwO2O,
                  {
                    [sty.textsoon__wwO2OwdK6]: hasVariant(
                      $state,
                      "soon",
                      "soon"
                    )
                  }
                )}
              >
                <React.Fragment>
                  {(() => {
                    try {
                      return $props.name;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              </div>
              {(hasVariant($state, "soon", "soon") ? true : false) ? (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rrEuk,
                    {
                      [sty.textsoon__rrEukwdK6]: hasVariant(
                        $state,
                        "soon",
                        "soon"
                      )
                    }
                  )}
                >
                  {"\u0628\u0632\u0648\u062f\u06cc"}
                </div>
              ) : null}
              {(hasVariant($state, "_new", "_new") ? true : false) ? (
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__gXiwI,
                    {
                      [sty.text_new__gXiwIgvzsl]: hasVariant(
                        $state,
                        "_new",
                        "_new"
                      )
                    }
                  )}
                >
                  {"\u062c\u062f\u06cc\u062f"}
                </div>
              ) : null}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__xiGce,
                {
                  [sty.textsoon__xiGcewdK6]: hasVariant($state, "soon", "soon")
                }
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return $props.description;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
            {(() => {
              try {
                return $props.showUsers;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <div
                className={classNames(projectcss.all, sty.freeBox__tPtNx)}
                onClick={async event => {
                  const $steps = {};

                  $steps["runCode"] = true
                    ? (() => {
                      const actionArgs = {
                        customFunction: async () => {
                          return event?.stopPropagation();
                        }
                      };
                      return (({ customFunction }) => {
                        return customFunction();
                      })?.apply(null, [actionArgs]);
                    })()
                    : undefined;
                  if (
                    $steps["runCode"] != null &&
                    typeof $steps["runCode"] === "object" &&
                    typeof $steps["runCode"].then === "function"
                  ) {
                    $steps["runCode"] = await $steps["runCode"];
                  }
                }}
              >
                <ApiRequest
                  data-plasmic-name={"apiRequest"}
                  data-plasmic-override={overrides.apiRequest}
                  className={classNames("__wab_instance", sty.apiRequest)}
                  errorDisplay={null}
                  loadingDisplay={
                    <React.Fragment>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__vIhjf
                        )}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return [2, 3, 4, 5];
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const currentItem = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox__yocM3
                                )}
                                key={currentIndex}
                              />
                            );
                          })}
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__kn2P4
                        )}
                      />
                    </React.Fragment>
                  }
                  method={"GET"}
                  onError={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "apiRequest",
                      "error"
                    ]).apply(null, eventArgs);
                  }}
                  onLoading={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "apiRequest",
                      "loading"
                    ]).apply(null, eventArgs);
                  }}
                  onSuccess={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "apiRequest",
                      "data"
                    ]).apply(null, eventArgs);
                  }}
                  ref={ref => {
                    $refs["apiRequest"] = ref;
                  }}
                  url={(() => {
                    try {
                      return `https://hamdast.paziresh24.com/api/v1/apps/${$props.appkey}/users?page=1&limit=4`;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                >
                  <Paziresh24Modal
                    data-plasmic-name={"modal"}
                    data-plasmic-override={overrides.modal}
                    body={
                      <React.Fragment>
                        <SideEffect
                          data-plasmic-name={"sideEffect"}
                          data-plasmic-override={overrides.sideEffect}
                          className={classNames(
                            "__wab_instance",
                            sty.sideEffect
                          )}
                          deps={(() => {
                            try {
                              return [$state.page];
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          onMount={async () => {
                            const $steps = {};

                            $steps["updateIsUsersLoading"] = true
                              ? (() => {
                                const actionArgs = {
                                  variable: {
                                    objRoot: $state,
                                    variablePath: ["isUsersLoading"]
                                  },
                                  operation: 0,
                                  value: true
                                };
                                return (({
                                  variable,
                                  value,
                                  startIndex,
                                  deleteCount
                                }) => {
                                  if (!variable) {
                                    return;
                                  }
                                  const { objRoot, variablePath } = variable;

                                  $stateSet(objRoot, variablePath, value);
                                  return value;
                                })?.apply(null, [actionArgs]);
                              })()
                              : undefined;
                            if (
                              $steps["updateIsUsersLoading"] != null &&
                              typeof $steps["updateIsUsersLoading"] ===
                              "object" &&
                              typeof $steps["updateIsUsersLoading"].then ===
                              "function"
                            ) {
                              $steps["updateIsUsersLoading"] = await $steps[
                                "updateIsUsersLoading"
                              ];
                            }

                            $steps["api"] = true
                              ? (() => {
                                const actionArgs = {
                                  args: [
                                    undefined,
                                    (() => {
                                      try {
                                        return `https://hamdast.paziresh24.com/api/v1/apps/${$props.appkey}/users?page=${$state.page}`;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                        ) {
                                          return undefined;
                                        }
                                        throw e;
                                      }
                                    })()
                                  ]
                                };
                                return $globalActions[
                                  "Fragment.apiRequest"
                                ]?.apply(null, [...actionArgs.args]);
                              })()
                              : undefined;
                            if (
                              $steps["api"] != null &&
                              typeof $steps["api"] === "object" &&
                              typeof $steps["api"].then === "function"
                            ) {
                              $steps["api"] = await $steps["api"];
                            }

                            $steps["updateUserList"] =
                              $steps.api?.data?.users?.length > 0
                                ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: ["userList"]
                                    },
                                    operation: 0,
                                    value: [
                                      ...$state.userList,
                                      ...($steps?.api?.data?.users ?? [])
                                    ]
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } =
                                      variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                                : undefined;
                            if (
                              $steps["updateUserList"] != null &&
                              typeof $steps["updateUserList"] === "object" &&
                              typeof $steps["updateUserList"].then ===
                              "function"
                            ) {
                              $steps["updateUserList"] = await $steps[
                                "updateUserList"
                              ];
                            }

                            $steps["updateShowPaginationButton"] =
                              $steps.api?.data?.users?.length < 20
                                ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: ["showPaginationButton"]
                                    },
                                    operation: 0,
                                    value: false
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } =
                                      variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                                : undefined;
                            if (
                              $steps["updateShowPaginationButton"] != null &&
                              typeof $steps["updateShowPaginationButton"] ===
                              "object" &&
                              typeof $steps["updateShowPaginationButton"]
                                .then === "function"
                            ) {
                              $steps["updateShowPaginationButton"] =
                                await $steps["updateShowPaginationButton"];
                            }

                            $steps["updateIsUsersLoading2"] = true
                              ? (() => {
                                const actionArgs = {
                                  variable: {
                                    objRoot: $state,
                                    variablePath: ["isUsersLoading"]
                                  },
                                  operation: 0,
                                  value: false
                                };
                                return (({
                                  variable,
                                  value,
                                  startIndex,
                                  deleteCount
                                }) => {
                                  if (!variable) {
                                    return;
                                  }
                                  const { objRoot, variablePath } = variable;

                                  $stateSet(objRoot, variablePath, value);
                                  return value;
                                })?.apply(null, [actionArgs]);
                              })()
                              : undefined;
                            if (
                              $steps["updateIsUsersLoading2"] != null &&
                              typeof $steps["updateIsUsersLoading2"] ===
                              "object" &&
                              typeof $steps["updateIsUsersLoading2"].then ===
                              "function"
                            ) {
                              $steps["updateIsUsersLoading2"] = await $steps[
                                "updateIsUsersLoading2"
                              ];
                            }
                          }}
                        />

                        {(() => {
                          try {
                            return $state.userList.length != 0;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___3WDk
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox__ki5Y
                              )}
                            >
                              {(_par =>
                                !_par
                                  ? []
                                  : Array.isArray(_par)
                                    ? _par
                                    : [_par])(
                                      (() => {
                                        try {
                                          return $state.userList;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })()
                                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                                      const currentItem = __plasmic_item_0;
                                      const currentIndex = __plasmic_idx_0;
                                      return (
                                        <div
                                          className={classNames(
                                            projectcss.all,
                                            sty.freeBox__ptGgo
                                          )}
                                          key={currentIndex}
                                        >
                                          <PlasmicImg__
                                            alt={""}
                                            className={classNames(
                                              sty.img__ndDfE,
                                              "bg-white"
                                            )}
                                            displayHeight={"70px"}
                                            displayMaxHeight={"none"}
                                            displayMaxWidth={"100%"}
                                            displayMinHeight={"0"}
                                            displayMinWidth={"0"}
                                            displayWidth={"70px"}
                                            loading={"eager"}
                                            onClick={async event => {
                                              const $steps = {};

                                              $steps["updateClickUserLoading"] = true
                                                ? (() => {
                                                  const actionArgs = {
                                                    variable: {
                                                      objRoot: $state,
                                                      variablePath: [
                                                        "clickUserLoading"
                                                      ]
                                                    },
                                                    operation: 0,
                                                    value: true
                                                  };
                                                  return (({
                                                    variable,
                                                    value,
                                                    startIndex,
                                                    deleteCount
                                                  }) => {
                                                    if (!variable) {
                                                      return;
                                                    }
                                                    const {
                                                      objRoot,
                                                      variablePath
                                                    } = variable;

                                                    $stateSet(
                                                      objRoot,
                                                      variablePath,
                                                      value
                                                    );
                                                    return value;
                                                  })?.apply(null, [actionArgs]);
                                                })()
                                                : undefined;
                                              if (
                                                $steps["updateClickUserLoading"] !=
                                                null &&
                                                typeof $steps[
                                                "updateClickUserLoading"
                                                ] === "object" &&
                                                typeof $steps[
                                                  "updateClickUserLoading"
                                                ].then === "function"
                                              ) {
                                                $steps["updateClickUserLoading"] =
                                                  await $steps[
                                                    "updateClickUserLoading"
                                                  ];
                                              }

                                              $steps["api"] = true
                                                ? (() => {
                                                  const actionArgs = {
                                                    args: [
                                                      undefined,
                                                      "https://apigw.paziresh24.com/v1/providers",
                                                      (() => {
                                                        try {
                                                          return {
                                                            user_id:
                                                              currentItem?.user_id
                                                          };
                                                        } catch (e) {
                                                          if (
                                                            e instanceof
                                                            TypeError ||
                                                            e?.plasmicType ===
                                                            "PlasmicUndefinedDataError"
                                                          ) {
                                                            return undefined;
                                                          }
                                                          throw e;
                                                        }
                                                      })()
                                                    ]
                                                  };
                                                  return $globalActions[
                                                    "Fragment.apiRequest"
                                                  ]?.apply(null, [
                                                    ...actionArgs.args
                                                  ]);
                                                })()
                                                : undefined;
                                              if (
                                                $steps["api"] != null &&
                                                typeof $steps["api"] === "object" &&
                                                typeof $steps["api"].then ===
                                                "function"
                                              ) {
                                                $steps["api"] = await $steps["api"];
                                              }

                                              $steps["runCode"] = true
                                                ? (() => {
                                                  const actionArgs = {
                                                    customFunction: async () => {
                                                      return globalThis.open(
                                                        `/dr/${$steps?.api?.data?.providers?.[0]?.slug}`,
                                                        "_blank"
                                                      );
                                                    }
                                                  };
                                                  return (({ customFunction }) => {
                                                    return customFunction();
                                                  })?.apply(null, [actionArgs]);
                                                })()
                                                : undefined;
                                              if (
                                                $steps["runCode"] != null &&
                                                typeof $steps["runCode"] ===
                                                "object" &&
                                                typeof $steps["runCode"].then ===
                                                "function"
                                              ) {
                                                $steps["runCode"] = await $steps[
                                                  "runCode"
                                                ];
                                              }

                                              $steps["updateClickUserLoading2"] = true
                                                ? (() => {
                                                  const actionArgs = {
                                                    variable: {
                                                      objRoot: $state,
                                                      variablePath: [
                                                        "clickUserLoading"
                                                      ]
                                                    },
                                                    operation: 0,
                                                    value: false
                                                  };
                                                  return (({
                                                    variable,
                                                    value,
                                                    startIndex,
                                                    deleteCount
                                                  }) => {
                                                    if (!variable) {
                                                      return;
                                                    }
                                                    const {
                                                      objRoot,
                                                      variablePath
                                                    } = variable;

                                                    $stateSet(
                                                      objRoot,
                                                      variablePath,
                                                      value
                                                    );
                                                    return value;
                                                  })?.apply(null, [actionArgs]);
                                                })()
                                                : undefined;
                                              if (
                                                $steps["updateClickUserLoading2"] !=
                                                null &&
                                                typeof $steps[
                                                "updateClickUserLoading2"
                                                ] === "object" &&
                                                typeof $steps[
                                                  "updateClickUserLoading2"
                                                ].then === "function"
                                              ) {
                                                $steps["updateClickUserLoading2"] =
                                                  await $steps[
                                                    "updateClickUserLoading2"
                                                  ];
                                              }
                                            }}
                                            src={(() => {
                                              try {
                                                return currentItem.image_url;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()}
                                            width={``}
                                          />
                                        </div>
                                      );
                                    })}
                            </div>
                            {(() => {
                              try {
                                return $state.showPaginationButton;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <Paziresh24Button
                                data-plasmic-name={"paziresh24Button"}
                                data-plasmic-override={
                                  overrides.paziresh24Button
                                }
                                children2={
                                  "\u0645\u0634\u0627\u0647\u062f\u0647 \u0628\u06cc\u0634\u062a\u0631"
                                }
                                className={classNames(
                                  "__wab_instance",
                                  sty.paziresh24Button
                                )}
                                loading={(() => {
                                  try {
                                    return $state.isUsersLoading;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })()}
                                onClick={async event => {
                                  const $steps = {};

                                  $steps["updatePage"] = !$state.isUsersLoading
                                    ? (() => {
                                      const actionArgs = {
                                        variable: {
                                          objRoot: $state,
                                          variablePath: ["page"]
                                        },
                                        operation: 2
                                      };
                                      return (({
                                        variable,
                                        value,
                                        startIndex,
                                        deleteCount
                                      }) => {
                                        if (!variable) {
                                          return;
                                        }
                                        const { objRoot, variablePath } =
                                          variable;

                                        const oldValue = $stateGet(
                                          objRoot,
                                          variablePath
                                        );
                                        $stateSet(
                                          objRoot,
                                          variablePath,
                                          oldValue + 1
                                        );
                                        return oldValue + 1;
                                      })?.apply(null, [actionArgs]);
                                    })()
                                    : undefined;
                                  if (
                                    $steps["updatePage"] != null &&
                                    typeof $steps["updatePage"] === "object" &&
                                    typeof $steps["updatePage"].then ===
                                    "function"
                                  ) {
                                    $steps["updatePage"] = await $steps[
                                      "updatePage"
                                    ];
                                  }

                                  $steps["updateIsUsersLoading"] = true
                                    ? (() => {
                                      const actionArgs = {
                                        variable: {
                                          objRoot: $state,
                                          variablePath: ["isUsersLoading"]
                                        },
                                        operation: 0,
                                        value: true
                                      };
                                      return (({
                                        variable,
                                        value,
                                        startIndex,
                                        deleteCount
                                      }) => {
                                        if (!variable) {
                                          return;
                                        }
                                        const { objRoot, variablePath } =
                                          variable;

                                        $stateSet(
                                          objRoot,
                                          variablePath,
                                          value
                                        );
                                        return value;
                                      })?.apply(null, [actionArgs]);
                                    })()
                                    : undefined;
                                  if (
                                    $steps["updateIsUsersLoading"] != null &&
                                    typeof $steps["updateIsUsersLoading"] ===
                                    "object" &&
                                    typeof $steps["updateIsUsersLoading"]
                                      .then === "function"
                                  ) {
                                    $steps["updateIsUsersLoading"] =
                                      await $steps["updateIsUsersLoading"];
                                  }
                                }}
                                outline={true}
                                size={"compact"}
                              />
                            ) : null}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return $state.clickUserLoading;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__lpc83
                            )}
                          >
                            <LauncherIconsLoaderIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__sbCa
                              )}
                              role={"img"}
                            />
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return (
                              $state.isUsersLoading &&
                              $state.userList.length == 0
                            );
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__sbq3H
                            )}
                          >
                            <LauncherIconsLoaderIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__tl9Md
                              )}
                              role={"img"}
                            />
                          </div>
                        ) : null}
                      </React.Fragment>
                    }
                    className={classNames("__wab_instance", sty.modal)}
                    onOpenChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "modal",
                        "open"
                      ]).apply(null, eventArgs);

                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }

                      (async val => {
                        const $steps = {};

                        $steps["updateUserList"] = true
                          ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["userList"]
                              },
                              operation: 0,
                              value: []
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                          : undefined;
                        if (
                          $steps["updateUserList"] != null &&
                          typeof $steps["updateUserList"] === "object" &&
                          typeof $steps["updateUserList"].then === "function"
                        ) {
                          $steps["updateUserList"] = await $steps[
                            "updateUserList"
                          ];
                        }

                        $steps["updatePage"] = true
                          ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["page"]
                              },
                              operation: 0,
                              value: 1
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                          : undefined;
                        if (
                          $steps["updatePage"] != null &&
                          typeof $steps["updatePage"] === "object" &&
                          typeof $steps["updatePage"].then === "function"
                        ) {
                          $steps["updatePage"] = await $steps["updatePage"];
                        }
                      }).apply(null, eventArgs);
                    }}
                    open={generateStateValueProp($state, ["modal", "open"])}
                    title={
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__qxIby
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___0FQhl
                          )}
                        >
                          {
                            "\u062d\u0631\u0641\u0647\u200c\u0627\u06cc \u0647\u0627"
                          }
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__bEsud
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {
                                "\u0628\u0627 \u06a9\u0644\u06cc\u06a9 \u0628\u0631 \u0631\u0648\u06cc \u0647\u0631 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644 \u0627\u0628\u0632\u0627\u0631\u06a9 "
                              }
                            </React.Fragment>
                            {
                              <span
                                className={classNames(
                                  projectcss.all,
                                  projectcss.span,
                                  projectcss.__wab_text,
                                  projectcss.plasmic_default__inline,
                                  sty.span__sYcG
                                )}
                              >
                                <React.Fragment>
                                  {(() => {
                                    try {
                                      return $props.name;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                      ) {
                                        return "-";
                                      }
                                      throw e;
                                    }
                                  })()}
                                </React.Fragment>
                              </span>
                            }
                            <React.Fragment>
                              {
                                " \u0631\u0627 \u0645\u0634\u0627\u0647\u062f\u0647 \u06a9\u0646\u06cc\u062f."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </div>
                      </div>
                    }
                    trigger={
                      <React.Fragment>
                        {(() => {
                          try {
                            return $state.apiRequest?.data?.active_users > 0;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__ld5Zl
                            )}
                          >
                            {(_par =>
                              !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                                (() => {
                                  try {
                                    return $state.apiRequest.data?.users
                                      ?.slice(0, 4)
                                      ?.reverse();
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })()
                              ).map((__plasmic_item_0, __plasmic_idx_0) => {
                                const currentItem = __plasmic_item_0;
                                const currentIndex = __plasmic_idx_0;
                                return (
                                  <PlasmicImg__
                                    alt={""}
                                    className={classNames(
                                      sty.img__tUwbH,
                                      "bg-white"
                                    )}
                                    displayHeight={"23px"}
                                    displayMaxHeight={"23px"}
                                    displayMaxWidth={"23%"}
                                    displayMinHeight={"23px"}
                                    displayMinWidth={"23px"}
                                    displayWidth={
                                      hasVariant(
                                        globalVariants,
                                        "screen",
                                        "mobileOnly"
                                      )
                                        ? "auto"
                                        : "28px"
                                    }
                                    key={currentIndex}
                                    loading={"eager"}
                                    src={(() => {
                                      try {
                                        return currentItem.image_url;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                        ) {
                                          return undefined;
                                        }
                                        throw e;
                                      }
                                    })()}
                                    width={``}
                                  />
                                );
                              })}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return $state.apiRequest?.data?.active_users > 0;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__iNssD,
                              {
                                [sty.textsoon__iNssDwdK6]: hasVariant(
                                  $state,
                                  "soon",
                                  "soon"
                                )
                              }
                            )}
                          >
                            <React.Fragment>
                              {(() => {
                                try {
                                  return (
                                    $state.apiRequest?.data?.active_users.toLocaleString(
                                      "fa-IR"
                                    ) + " کاربر فعال"
                                  );
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                    "PlasmicUndefinedDataError"
                                  ) {
                                    return "";
                                  }
                                  throw e;
                                }
                              })()}
                            </React.Fragment>
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return !$state.apiRequest?.data?.active_users;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__tVxhk
                            )}
                          >
                            {(_par =>
                              !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                                (() => {
                                  try {
                                    return [2, 3, 4, 5];
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })()
                              ).map((__plasmic_item_0, __plasmic_idx_0) => {
                                const currentItem = __plasmic_item_0;
                                const currentIndex = __plasmic_idx_0;
                                return (
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      sty.freeBox__wiIy
                                    )}
                                    key={currentIndex}
                                  />
                                );
                              })}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return !$state.apiRequest?.data?.active_users;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox___8Cb
                            )}
                          />
                        ) : null}
                      </React.Fragment>
                    }
                  />
                </ApiRequest>
              </div>
            ) : null}
          </div>
        </div>
        <ApiRequest
          data-plasmic-name={"apiRequest2"}
          data-plasmic-override={overrides.apiRequest2}
          className={classNames("__wab_instance", sty.apiRequest2)}
          errorDisplay={null}
          loadingDisplay={null}
          method={"GET"}
          onError={async (...eventArgs: any) => {
            generateStateOnChangeProp($state, ["apiRequest2", "error"]).apply(
              null,
              eventArgs
            );
          }}
          onLoading={async (...eventArgs: any) => {
            generateStateOnChangeProp($state, ["apiRequest2", "loading"]).apply(
              null,
              eventArgs
            );
          }}
          onSuccess={async (...eventArgs: any) => {
            generateStateOnChangeProp($state, ["apiRequest2", "data"]).apply(
              null,
              eventArgs
            );
          }}
          ref={ref => {
            $refs["apiRequest2"] = ref;
          }}
          url={(() => {
            try {
              return `https://apigw.paziresh24.com/v1/hamdast/apps/${$props.appkey}/performance`;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox___7S8MY)}
            onClick={async event => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                  const actionArgs = {
                    customFunction: async () => {
                      return event?.stopPropagation();
                    }
                  };
                  return (({ customFunction }) => {
                    return customFunction();
                  })?.apply(null, [actionArgs]);
                })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }

              $steps["invokeGlobalAction"] = true
                ? (() => {
                  const actionArgs = {
                    args: [
                      (() => {
                        try {
                          return {
                            evant_group: "launcher_statistics",
                            event_type: "apps-performance",
                            is_doctor: $ctx.auth.info?.is_doctor,
                            user_id: $ctx?.auth?.info?.id,
                            meta_data: {
                              name: $props.name,
                              key: $props.appkey
                            }
                          };
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()
                    ]
                  };
                  return $globalActions["Splunk.sendLog"]?.apply(null, [
                    ...actionArgs.args
                  ]);
                })()
                : undefined;
              if (
                $steps["invokeGlobalAction"] != null &&
                typeof $steps["invokeGlobalAction"] === "object" &&
                typeof $steps["invokeGlobalAction"].then === "function"
              ) {
                $steps["invokeGlobalAction"] = await $steps[
                  "invokeGlobalAction"
                ];
              }
            }}
          >
            <Paziresh24Modal
              data-plasmic-name={"modal2"}
              data-plasmic-override={overrides.modal2}
              body={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__veL4
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {
                        "\u0627\u0632 \u0647\u0631 \u06f1\u06f0\u06f0 \u0646\u0641\u0631\u06cc \u06a9\u0647 \u0627\u0628\u0632\u0627\u0631\u06a9 "
                      }
                    </React.Fragment>
                    {
                      <span
                        className={classNames(
                          projectcss.all,
                          projectcss.span,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.span__nec5N
                        )}
                      >
                        <React.Fragment>
                          {(() => {
                            try {
                              return $props.name;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "-";
                              }
                              throw e;
                            }
                          })()}
                        </React.Fragment>
                      </span>
                    }
                    <React.Fragment>
                      {
                        " \u0631\u0648 \u062f\u0631 \u067e\u0631\u0648\u0641\u0627\u06cc\u0644 \u0634\u0645\u0627 \u062f\u06cc\u062f\u0646\u060c "
                      }
                    </React.Fragment>
                    {
                      <span
                        className={classNames(
                          projectcss.all,
                          projectcss.span,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.span__r004B
                        )}
                      >
                        <React.Fragment>
                          {(() => {
                            try {
                              return $state.apiRequest2.data?.metrics?.ctr?.toFixed();
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "-";
                              }
                              throw e;
                            }
                          })()}
                        </React.Fragment>
                      </span>
                    }
                    <React.Fragment>
                      {
                        " \u0646\u0641\u0631 \u0631\u0648\u0634 \u06a9\u0644\u06cc\u06a9 \u06a9\u0631\u062f\u0646!"
                      }
                    </React.Fragment>
                  </React.Fragment>
                </div>
              }
              className={classNames("__wab_instance", sty.modal2)}
              onOpenChange={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, ["modal2", "open"]).apply(
                  null,
                  eventArgs
                );

                if (
                  eventArgs.length > 1 &&
                  eventArgs[1] &&
                  eventArgs[1]._plasmic_state_init_
                ) {
                  return;
                }
              }}
              open={generateStateValueProp($state, ["modal2", "open"])}
              title={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__wAUj9
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {
                        "\u062a\u0627\u062b\u06cc\u0631 \u0627\u0628\u0632\u0627\u0631\u06a9 "
                      }
                    </React.Fragment>
                    {
                      <span
                        className={classNames(
                          projectcss.all,
                          projectcss.span,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.span__s7Tkc
                        )}
                      >
                        <React.Fragment>
                          {(() => {
                            try {
                              return $props.name;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "-";
                              }
                              throw e;
                            }
                          })()}
                        </React.Fragment>
                      </span>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              }
              trigger={
                (() => {
                  try {
                    return (
                      !!$state?.apiRequest2?.data?.metrics?.total_clicks > 0
                    );
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return true;
                    }
                    throw e;
                  }
                })() ? (
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mamZf)}
                    onClick={async event => {
                      const $steps = {};
                    }}
                  >
                    <Icon10Icon
                      className={classNames(projectcss.all, sty.svg__rykr)}
                      role={"img"}
                    />

                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___8Jki9
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__q1ZrL
                        )}
                      >
                        <React.Fragment>
                          {$state.apiRequest2.data.metrics.total_clicks}
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__fKHqS
                        )}
                      >
                        {"\u06a9\u0644\u06cc\u06a9"}
                      </div>
                    </div>
                  </div>
                ) : null
              }
            />
          </div>
        </ApiRequest>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "fragmentPortal",
    "hamdastAppFrame",
    "apiRequest",
    "modal",
    "sideEffect",
    "paziresh24Button",
    "apiRequest2",
    "modal2"
  ],
  fragmentPortal: ["fragmentPortal", "hamdastAppFrame"],
  hamdastAppFrame: ["hamdastAppFrame"],
  apiRequest: ["apiRequest", "modal", "sideEffect", "paziresh24Button"],
  modal: ["modal", "sideEffect", "paziresh24Button"],
  sideEffect: ["sideEffect"],
  paziresh24Button: ["paziresh24Button"],
  apiRequest2: ["apiRequest2", "modal2"],
  modal2: ["modal2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  fragmentPortal: typeof Portal;
  hamdastAppFrame: typeof AppFrame;
  apiRequest: typeof ApiRequest;
  modal: typeof Paziresh24Modal;
  sideEffect: typeof SideEffect;
  paziresh24Button: typeof Paziresh24Button;
  apiRequest2: typeof ApiRequest;
  modal2: typeof Paziresh24Modal;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLauncherComponentsApp__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLauncherComponentsApp__VariantsArgs;
    args?: PlasmicLauncherComponentsApp__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLauncherComponentsApp__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
  // Specify args directly as props
  Omit<PlasmicLauncherComponentsApp__ArgsType, ReservedPropsType> &
  // Specify overrides for each element directly as props
  Omit<
    NodeOverridesType<T>,
    ReservedPropsType | VariantPropType | ArgPropType
  > &
  // Specify props for the root element
  Omit<
    Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
    ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
  >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLauncherComponentsApp__ArgProps,
          internalVariantPropNames: PlasmicLauncherComponentsApp__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLauncherComponentsApp__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLauncherComponentsApp";
  } else {
    func.displayName = `PlasmicLauncherComponentsApp.${nodeName}`;
  }
  return func;
}

export const PlasmicLauncherComponentsApp = Object.assign(
  // Top-level PlasmicLauncherComponentsApp renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    fragmentPortal: makeNodeComponent("fragmentPortal"),
    hamdastAppFrame: makeNodeComponent("hamdastAppFrame"),
    apiRequest: makeNodeComponent("apiRequest"),
    modal: makeNodeComponent("modal"),
    sideEffect: makeNodeComponent("sideEffect"),
    paziresh24Button: makeNodeComponent("paziresh24Button"),
    apiRequest2: makeNodeComponent("apiRequest2"),
    modal2: makeNodeComponent("modal2"),

    // Metadata about props expected for PlasmicLauncherComponentsApp
    internalVariantProps: PlasmicLauncherComponentsApp__VariantProps,
    internalArgProps: PlasmicLauncherComponentsApp__ArgProps
  }
);

export default PlasmicLauncherComponentsApp;
/* prettier-ignore-end */
